var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonStockCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 18.3333C14.5833 18.3333 18.3333 14.5833 18.3333 9.99999C18.3333 5.41666 14.5833 1.66666 9.99999 1.66666C5.41666 1.66666 1.66666 5.41666 1.66666 9.99999C1.66666 14.5833 5.41666 18.3333 9.99999 18.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5682 13.3182C12.5682 13.3182 12.5682 13.3182 10.6932 13.3182H8.44318C6.56818 13.3182 5.81818 12.5682 5.81818 10.6932V8.44318C5.81818 6.56818 6.56818 5.81818 8.44318 5.81818H10.3182",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1818 8.84545H11.9545C11.0341 8.84545 10.7273 8.53863 10.7273 7.61817V6.3909L13.1818 8.84545Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 9.875H9.875",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 11.375H9.125",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3805 12.1493C13.9472 12.1493 14.4067 11.6898 14.4067 11.1231C14.4067 10.5563 13.9472 10.0968 13.3805 10.0968C12.8137 10.0968 12.3542 10.5563 12.3542 11.1231C12.3542 11.6898 12.8137 12.1493 13.3805 12.1493Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6459 12.6459L14.1667 12.1667",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonStockCheck);
export default __webpack_public_path__ + "static/media/button-stock-check.c61df160480a7ed69307022058b14438.svg";
export { ForwardRef as ReactComponent };